function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.43313 16.0456C9.62681 16.0456 11.4126 14.2598 11.4126 12.0661C11.4126 9.87243 9.62681 8.08659 7.43313 8.08659C5.23946 8.08659 3.45362 9.87243 3.45362 12.0661C3.45362 14.2598 5.23946 16.0456 7.43313 16.0456ZM7.43313 9.0135C9.11701 9.0135 10.4857 10.3822 10.4857 12.0661C10.4857 13.75 9.11701 15.1187 7.43313 15.1187C5.74926 15.1187 4.38052 13.75 4.38052 12.0661C4.38052 10.3822 5.74926 9.0135 7.43313 9.0135Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1726 38.9834H0.82739C0.570946 38.9834 0.363937 39.1904 0.363937 39.4469C0.363937 39.7033 0.570946 39.9103 0.82739 39.9103H47.1726C47.4291 39.9103 47.6361 39.7033 47.6361 39.4469C47.6361 39.1904 47.4291 38.9834 47.1726 38.9834Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6468 42.0731H14.6105C14.354 42.0731 14.147 42.2801 14.147 42.5365C14.147 42.793 14.354 43 14.6105 43H25.6468C25.9033 43 26.1103 42.793 26.1103 42.5365C26.1103 42.2801 25.9033 42.0731 25.6468 42.0731Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2434 42.0731H28.8663C28.6098 42.0731 28.4028 42.2801 28.4028 42.5365C28.4028 42.793 28.6098 43 28.8663 43H35.2434C35.4998 43 35.7068 42.793 35.7068 42.5365C35.7068 42.2801 35.4998 42.0731 35.2434 42.0731Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5585 31.3952V37.5931C35.5585 37.8495 35.7655 38.0565 36.0219 38.0565C36.2784 38.0565 36.4854 37.8495 36.4854 37.5931V31.3952C36.4854 31.1387 36.2784 30.9317 36.0219 30.9317C35.7655 30.9317 35.5585 31.1387 35.5585 31.3952Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6482 37.5931C38.6482 37.8495 38.8552 38.0565 39.1116 38.0565C39.3681 38.0565 39.5751 37.8495 39.5751 37.5931V34.2964C39.5751 34.0399 39.3681 33.8329 39.1116 33.8329C38.8552 33.8329 38.6482 34.0399 38.6482 34.2964V37.5931Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3737 34.6053V37.5931C18.3737 37.8495 18.5807 38.0565 18.8372 38.0565C19.0936 38.0565 19.3006 37.8495 19.3006 37.5931V34.6053C19.3006 34.3489 19.0936 34.1419 18.8372 34.1419C18.5807 34.1419 18.3737 34.3489 18.3737 34.6053Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0779 28.4445V27.3322C10.0779 27.0758 9.87089 26.8688 9.61445 26.8688C9.358 26.8688 9.15099 27.0758 9.15099 27.3322V28.4445C9.15099 29.9924 10.4085 31.2499 11.9564 31.2499H12.2407V37.5931C12.2407 37.8495 12.4477 38.0565 12.7041 38.0565C12.9606 38.0565 13.1676 37.8495 13.1676 37.5931V34.4478H13.526C14.9812 34.4478 16.1646 33.2644 16.1646 31.8092V30.527C16.1646 30.2705 15.9576 30.0635 15.7011 30.0635C15.4447 30.0635 15.2377 30.2705 15.2377 30.527V31.8092C15.2377 32.7515 14.4714 33.5209 13.526 33.5209H13.1676V26.6618C13.1676 26.4053 12.9606 26.1983 12.7041 26.1983C12.4477 26.1983 12.2407 26.4053 12.2407 26.6618V30.323H11.9564C10.9214 30.323 10.0779 29.4796 10.0779 28.4445Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6457 28.6237H24.5623V37.5961C24.5623 37.8526 24.7693 38.0596 25.0258 38.0596C25.2822 38.0596 25.4892 37.8526 25.4892 37.5961V28.1603C25.4892 27.9038 25.2822 27.6968 25.0258 27.6968H21.6457C19.1956 27.6968 17.2027 25.704 17.2027 23.2538V17.3711C17.2027 16.2743 18.0956 15.3813 19.1925 15.3813C20.2893 15.3813 21.1822 16.2743 21.1822 17.3711V21.2054C21.1822 22.296 22.069 23.1859 23.1627 23.1859H25.0289C25.2853 23.1859 25.4923 22.9789 25.4923 22.7224V7.91666C25.4923 6.81982 26.3852 5.9269 27.4821 5.9269C28.5789 5.9269 29.4718 6.81982 29.4718 7.91666V16.6357C29.4718 16.8922 29.6788 17.0992 29.9353 17.0992H31.5543C32.7809 17.0992 33.7789 16.1012 33.7789 14.8746V13.0146C33.7789 11.9178 34.6718 11.0249 35.7686 11.0249C36.8655 11.0249 37.7584 11.9178 37.7584 13.0146V17.1672C37.7584 19.6173 35.7655 21.6101 33.3154 21.6101H29.9353C29.6788 21.6101 29.4718 21.8171 29.4718 22.0736V37.5931C29.4718 37.8495 29.6788 38.0565 29.9353 38.0565C30.1917 38.0565 30.3987 37.8495 30.3987 37.5931V22.537H33.3154C36.2753 22.537 38.6853 20.1271 38.6853 17.1672V13.0146C38.6853 11.4049 37.3752 10.098 35.7686 10.098C34.162 10.098 32.852 11.408 32.852 13.0146V14.8746C32.852 15.5883 32.2711 16.1723 31.5543 16.1723H30.3987V7.91666C30.3987 6.30694 29.0887 5 27.4821 5C25.8754 5 24.5654 6.31003 24.5654 7.91666V22.259H23.1627C22.5818 22.259 22.1091 21.7862 22.1091 21.2054V17.3711C22.1091 15.7614 20.7991 14.4544 19.1925 14.4544C17.5858 14.4544 16.2758 15.7645 16.2758 17.3711V23.2538C16.2758 26.2138 18.6858 28.6237 21.6457 28.6237Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSw);
export default __webpack_public_path__ + "static/media/SW.556b94f9dc9a01f325361c8bc4782a3d.svg";
export { ForwardRef as ReactComponent };